const RATE_LIMITS = {
  reviews: {
    key: 'ratethatdriver_v2_rate_reviews',
    max: 5,
    windowMs: 60 * 60 * 1000,
    message: 'Too many submissions, please wait',
  },
  searches: {
    key: 'ratethatdriver_v2_rate_searches',
    max: 10,
    windowMs: 60 * 1000,
    message: 'Too many submissions, please wait',
  },
};

function readTimestamps(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.map(Number).filter(Number.isFinite) : [];
  } catch {
    return [];
  }
}

function writeTimestamps(key, timestamps) {
  localStorage.setItem(key, JSON.stringify(timestamps));
}

function getWindowedTimestamps(config, now = Date.now()) {
  const windowStart = now - config.windowMs;
  return readTimestamps(config.key).filter((value) => value >= windowStart);
}

export function checkRateLimit(action) {
  const config = RATE_LIMITS[action];
  if (!config) return { allowed: true };

  const timestamps = getWindowedTimestamps(config);

  if (timestamps.length >= config.max) {
    throw new Error(config.message);
  }

  return {
    allowed: true,
    remaining: Math.max(0, config.max - timestamps.length),
  };
}

export function commitRateLimit(action) {
  const config = RATE_LIMITS[action];
  if (!config) return { allowed: true };

  const now = Date.now();
  const timestamps = getWindowedTimestamps(config, now);

  if (timestamps.length >= config.max) {
    throw new Error(config.message);
  }

  timestamps.push(now);
  writeTimestamps(config.key, timestamps);

  return {
    allowed: true,
    remaining: Math.max(0, config.max - timestamps.length),
  };
}

export function consumeRateLimit(action) {
  checkRateLimit(action);
  return commitRateLimit(action);
}
